import React, { memo } from 'react'
import { buildActionsUI } from '../buildActionsUI'
import { useAppSelector } from '../../../hooks/useAppSelector'
import { selectOneCustomAction } from '../../../store/selectors/actionsSelectors/actionsSelectors'
import { selectProductActionsParameters } from '../../../store/selectors/actionsSelectors/actionsParametersSelectors'
import { PATH_JOINER } from '../../models/utils/getConfigBitPath'

interface ActionParametersProps {
    guid: string
    actionName: string
}

export const ActionParameters = memo(function ActionParameters({
    guid,
    actionName,
}: ActionParametersProps) {
    const currentAction = useAppSelector(selectOneCustomAction(guid, actionName))
    const productActionsParameters = useAppSelector(
        selectProductActionsParameters(guid)
    )
    const actionSchema = currentAction?.request_schema

    const actionComponent = buildActionsUI(
        [guid].join(PATH_JOINER),
        actionName,
        actionSchema,
        productActionsParameters,
        '',
    )

    return (
        <>
            <h5>Parameters</h5>
            <div className="d-flex flex-column gap-2">{actionComponent}</div>
        </>
    )
})
